import { useSelector } from 'src/store/react';
import { selectFeatureFlag } from 'src/store/selectors';

import { useIsFeatureFlagEnabled } from './hooks';

export const useSavedRecentSearchesFeatureFlag = (): boolean => {
  const isEnabled = useSelector(selectFeatureFlag('savedRecentSearches'));
  const flag = { isEnabled, variation: true };

  return useIsFeatureFlagEnabled('experiment-saved-recent-searches', flag);
};
